module.exports = __webpack_public_path__ + "img/mail_close.20274197.png";